module.exports = __webpack_public_path__ + "partner-cover.jpg?667c42df1bc4e512b985c5a0ff4404f7";